import { useEffect, useState } from 'react';

function useBlockSize({ observedBlock, delay = 300, sizes = [] }) {
  const [width, setWidth] = useState();
  const [height, setHeight] = useState();

  useEffect(() => {
    const element = observedBlock?.current;
    if (!element) return undefined;

    const resizeObserver = new ResizeObserver(() => {
      const nextWidth = element.offsetWidth;
      const nextHeight = element.offsetHeight;
      setWidth((prev) => (prev !== nextWidth ? nextWidth : prev));
      setHeight((prev) => (prev !== nextHeight ? nextHeight : prev));
    });

    resizeObserver.observe(element);
    return () => {
      resizeObserver.disconnect();
    };
  }, [observedBlock]);

  return {
    width: sizes.find((size) => width >= size.from && width < size.to)?.value,
    height: sizes.find((size) => height >= size.from && height < size.to)?.value,
  };
}

export default useBlockSize;
